import React from "react";
import LegalLayout from "@/components/LegalLayout";
import useSeo from "@/hooks/useSeo";

export default function ImpressumPage() {
  useSeo({
    title: "Impressum",
    description:
      "Impressum von Alex Buchner Health – Personal Training und Mikronährstoffberatung im Chiemgau.",
    path: "/impressum",
  });

  return (
    <LegalLayout title="Impressum">
      <section data-testid="impressum-tmg">
        <h2 className="font-display text-xl font-bold mt-6 mb-3">
          Angaben gemäß § 5 TMG
        </h2>
        <p>
          Personal Training und Mikronährstoffberatung Alex Buchner
          <br />
          Postfach Traunsteiner Straße 27
          <br />
          83334 Inzell
        </p>
      </section>

      <section data-testid="impressum-contact">
        <h2 className="font-display text-xl font-bold mt-6 mb-3">Kontakt</h2>
        <p>
          Telefon: +49 (0) 175 1515 725
          <br />
          E-Mail:{" "}
          <a
            href="mailto:info@alex-buchner-health.de"
            className="text-[#2E89C4] hover:underline"
          >
            info@alex-buchner-health.de
          </a>
          <br />
          Website:{" "}
          <a
            href="https://www.alex-buchner-health.de"
            className="text-[#2E89C4] hover:underline"
            target="_blank"
            rel="noreferrer"
          >
            www.alex-buchner-health.de
          </a>
        </p>
      </section>

      <section data-testid="impressum-ustid">
        <h2 className="font-display text-xl font-bold mt-6 mb-3">
          Umsatzsteuer-Identifikationsnummer
        </h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
          <br />
          <strong>DE457667752</strong>
        </p>
      </section>

      <section data-testid="impressum-job">
        <h2 className="font-display text-xl font-bold mt-6 mb-3">
          Berufsbezeichnung & Qualifikationen
        </h2>
        <p>
          Bachelor of Arts Sportökonomie
          <br />
          Fitness-Trainer B-Lizenz
          <br />
          Athletiktrainer A-Lizenz
          <br />
          Zertifizierter Mikronährstoffcoach
        </p>
      </section>

      <section data-testid="impressum-disclaimer">
        <h2 className="font-display text-xl font-bold mt-8 mb-3">
          Haftungsausschluss – Disclaimer
        </h2>

        <h3 className="font-semibold mt-4 mb-2">Haftung für Inhalte</h3>
        <p>
          Alle Inhalte unseres Internetauftritts wurden mit größter Sorgfalt und
          nach bestem Gewissen erstellt. Für die Richtigkeit, Vollständigkeit
          und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte
          auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
          §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
          verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
          überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der
          Nutzung von Informationen nach den allgemeinen Gesetzen bleiben
          hiervon unberührt.
        </p>
        <p>
          Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
          Kenntniserlangung einer konkreten Rechtsverletzung möglich. Bei
          Bekanntwerden von den o. g. Rechtsverletzungen werden wir diese
          Inhalte unverzüglich entfernen.
        </p>

        <h3 className="font-semibold mt-4 mb-2">
          Haftungsbeschränkung für externe Links
        </h3>
        <p>
          Unsere Webseite enthält Links auf externe Webseiten Dritter. Auf die
          Inhalte dieser direkt oder indirekt verlinkten Webseiten haben wir
          keinen Einfluss. Daher können wir für die „externen Links" auch keine
          Gewähr auf Richtigkeit der Inhalte übernehmen. Für die Inhalte der
          externen Links sind die jeweiligen Anbieter oder Betreiber (Urheber)
          der Seiten verantwortlich.
        </p>
        <p>
          Die externen Links wurden zum Zeitpunkt der Linksetzung auf eventuelle
          Rechtsverstöße überprüft und waren im Zeitpunkt der Linksetzung frei
          von rechtswidrigen Inhalten. Eine ständige inhaltliche Überprüfung der
          externen Links ist ohne konkrete Anhaltspunkte einer Rechtsverletzung
          nicht möglich. Bei direkten oder indirekten Verlinkungen auf die
          Webseiten Dritter, die außerhalb unseres Verantwortungsbereichs
          liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall
          nur bestehen, wenn wir von den Inhalten Kenntnis erlangen und es uns
          technisch möglich und zumutbar wäre, die Nutzung im Falle
          rechtswidriger Inhalte zu verhindern.
        </p>
        <p>
          Werden uns Rechtsverletzungen bekannt, werden die externen Links durch
          uns unverzüglich entfernt.
        </p>

        <h3 className="font-semibold mt-4 mb-2">Urheberrecht</h3>
        <p>
          Die auf unserer Webseite veröffentlichten Inhalte und Werke
          unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung des geistigen
          Eigentums in ideeller und materieller Sicht des Urhebers außerhalb der
          Grenzen des Urheberrechtes bedürfen der vorherigen schriftlichen
          Zustimmung des jeweiligen Urhebers i.S.d. Urhebergesetzes. Downloads
          und Kopien dieser Seite sind nur für den privaten und nicht
          kommerziellen Gebrauch erlaubt. Sind die Inhalte auf unserer Webseite
          nicht von uns erstellt worden, sind die Urheberrechte Dritter zu
          beachten. Die Inhalte Dritter werden als solche kenntlich gemacht.
          Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam
          werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden
          von Rechtsverletzungen werden wir derartige Inhalte unverzüglich
          entfernen.
        </p>
      </section>
    </LegalLayout>
  );
}
